import { HTMLAttributes } from 'react'
import classNames from 'classnames'

export type SpacerProps = HTMLAttributes<HTMLHRElement> & {
  variant?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
}

const Spacer = ({ variant = '2xl', className, ...props }: SpacerProps) => {
  const variantClasses = {
    xxs: 'h-xxs md:h-xs',
    xs: 'h-xs md:h-md',
    sm: 'h-sm md:h-xl',
    md: 'h-md md:h-3xl',
    lg: 'h-lg md:h-4xl',
    xl: 'h-xl md:h-5xl',
    '2xl': 'h-2xl md:h-6xl'
  }

  return (
    <hr
      className={classNames(
        'border-0 bg-transparent',
        variantClasses[variant],
        className
      )}
      {...props}
    />
  )
}

export default Spacer
